export const SetPdfFiles = 'documentInteract/SET_PDF_FILES';
export const SetPagesForFile = 'documentInteract/SET_PAGES_FOR_FILE';
export const ResetPagesRendered = 'documentInteract/RESET_PAGES_RENDERED';
export const SetPageRendered = 'documentInteract/SET_PAGE_RENDERED';
export const Clear = 'documentInteract/CLEAR';
